import React from "react";

export function HomeDashboardLoading({ tip = "Yükleniyor…" }) {
  return (
    <div className="home-dash-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="home-dash-loading__stage" aria-hidden>
        <span className="home-dash-loading__glow" />
        <span className="home-dash-loading__ring home-dash-loading__ring--outer" />
        <span className="home-dash-loading__ring home-dash-loading__ring--inner" />
        <span className="home-dash-loading__dot home-dash-loading__dot--a" />
        <span className="home-dash-loading__dot home-dash-loading__dot--b" />
        <span className="home-dash-loading__dot home-dash-loading__dot--c" />
        <span className="home-dash-loading__core" />
      </div>
      <p className="home-dash-loading__tip">{tip}</p>
    </div>
  );
}

export default HomeDashboardLoading;
